import {pageInfo, initPage, batchConfirm, modifyVendorTypeInitPage, modifyVendorTypeSubmit} from './../api';
import { initUpdate } from '../../../yard/printShipOrder/api'
const orderPickupNotice = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    podShowRes: null,
    printResp: null,
    confirmData: null,
    modifyVendorTypeInitPageResp: null,
    modifyVendorTypeSubmitResp: null
  },
  mutations: {
    PAGE_INFO(state,data){
      state.pageResp = (data.obj || []).map(item =>({ ...item, btns: [item.existEmptyVendorTypeFlag === 'Y', true] }));
      state.total = data.total;
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    DO_PRINT(state,data){
      state.printResp = data;
    },
    YARD_PRINT_GATEPASS(state, data) {
      state.printGatepassSubmitResp = data;
    },
    BATCH_CONFIRM(state, data) {
      state.confirmData = data;
    },
    MODIFY_VENDOR_TYPE_INIT_PAGE(state, data) {
      state.modifyVendorTypeInitPageResp = data.obj || {};
    },
    MODIFY_VENDOR_TYPE_SUBMIT(state, data) {
      state.modifyVendorTypeSubmitResp = data;
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    async batchConfirm({commit}, obj){
      let resp = await batchConfirm(obj);
      commit('BATCH_CONFIRM', resp);
    },
    //初始化更新对象事件
    async modifyVendorTypeInitPage({commit}, obj){
      let resp = await modifyVendorTypeInitPage(obj);
      commit('MODIFY_VENDOR_TYPE_INIT_PAGE', resp);
    },
    //供应商费用类型修改
    async modifyVendorTypeSubmit({commit}, obj) {
      let resp = await modifyVendorTypeSubmit(obj);
      commit('MODIFY_VENDOR_TYPE_SUBMIT', resp);
    }
  }
}
export default orderPickupNotice



// WEBPACK FOOTER //
// ./src/page/order/orderPickupNotice/store/orderPickupNotice.store.js